import { FC, ComponentPropsWithoutRef } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';

interface NavItemWrapperProps extends ComponentPropsWithoutRef<'li'> {
  className?: string;
}

const NavItemWrapper: FC<NavItemWrapperProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <li
      className={tailwindOverride(
        'w-full rounded mx-auto',
        'border-l-2',
        'ring-offset-transparent',
        'focus-within:bg-primary-darker',
        className
      )}
      {...props}
    >
      {children}
    </li>
  );
};

export default NavItemWrapper;
